// 통합 Debug Time Machine 엔진 (메인 진입점)
export * from './DebugTimeMachineEngine';

// 개별 모듈들
export * from './time-travel-engine/index';
export * from './types/index';
export * from './utils/index';

// 네트워크 인터셉터 (선택적 export로 충돌 방지)
export { 
  NetworkInterceptor,
  RealTimeAPIInterceptor, 
  AxiosInterceptor,
  getGlobalAPIInterceptor,
  destroyGlobalAPIInterceptor
} from './network-interceptor/index';

// WebSocket 커넥터는 별도로 export (타입 충돌 방지)
export { 
  WebSocketConnector,
  type IWebSocketConnectorMessage,
  type IWebSocketConnectorConfig 
} from './network-interceptor/WebSocketConnector';

// 에러 감지 시스템
export * from './error-detector/index';

// 상태 매핑 시스템
export * from './state-mapper/index';

// 메모리 및 최적화 모듈들
export * from './memory/MemoryManager';
export * from './dom-snapshot/DOMSnapshotOptimizer';
export * from './metrics/MetricsCollector';

// 편의 함수들 (간편한 사용을 위해)
export { 
  getGlobalDebugTimeMachine, 
  destroyGlobalDebugTimeMachine,
  startDebugTimeMachine,
  stopDebugTimeMachine 
} from './DebugTimeMachineEngine';
